'use client';
import { useSuspenseQuery } from '@tanstack/react-query';
import Categories from 'src/components/app/archive/components/info/category-and-tag/categories';

import Breadcrumb from '@/components/@base/breadcrumb';
import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import Props from '@/components/app/archive/components/info/category-and-tag/type';
import { getArchiveInfoQueryOptions } from '@/components/app/archive/services/hooks';

import CategoryModel from '@/models/category.model';
import TagModel from '@/models/tag.model';

export default function Info({ slug, type }: Props) {
  const { data } = useSuspenseQuery(getArchiveInfoQueryOptions(slug, type));

  function isCategory(data: CategoryModel | TagModel): data is CategoryModel {
    return (data as CategoryModel).tags !== undefined;
  }
  
  return (
    <Container className='gap-2 pb-2 pt-9 md:flex md:min-h-[220px] md:pb-6 md:pt-[18px]'>
      <Container className='flex flex-col justify-center gap-1 px-4 md:flex-1 md:gap-3 md:p-0'>
        <Breadcrumb
          className='text-[#737373]'
          excludeRoutes={['web', 'category', 'tag']}
          customLabels={{ [slug]: data.title }}
        />
        <Heading
          type={HEADING_TYPE.H1}
          className='text-[22px] font-bold text-[#424244] md:text-2xl'
          data-nosnippet
        >
          {data.title}
        </Heading>
        {isCategory(data) && (data.shortDescription || data.metaDescription) && (
          <Text className='text-[13px] font-medium text-[#878F9B]'>
            {data.shortDescription || data.metaDescription}
          </Text>
        )}
        {(type === 'tag') && data.shortDescription &&
         ( <Text className='text-[13px] font-medium text-[#878F9B]'>
            {data.shortDescription}
          </Text>)
        }
      </Container>
      <Container className='md:m-0 md:ml-2.5 md:flex-1'>
        {isCategory(data) && data.tags && data.tags.length > 0 && (
          <Categories tags={data.tags.slice(0, 4)} />
        )}
      </Container>
    </Container>
  );
}
